import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { FirstTimeFlag } from '../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../redux/firstTimeFlags/hooks';
export function useSubscriptionLockFTUE(deviation) {
    var ms_ftue_locked_art = useFlag('ms_ftue_locked_art');
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _a = useSubscriptionTier(deviation), isInTier = _a.isInTier, isOwner = _a.isOwner;
    var _b = useFirstTimeFlag(FirstTimeFlag.IsMsLockedArtNotSeen), isMsLockedArtNotSeen = _b.hasFlag, dropFlag = _b.dropFlag;
    return {
        isSubscriptionLockFTUEShown: ms_ftue_locked_art &&
            isLoggedIn &&
            isInTier &&
            !isOwner &&
            isMsLockedArtNotSeen,
        dropFlag: dropFlag,
    };
}
//# sourceMappingURL=useSubscriptionLockFTUE.js.map